import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class AmountOfPaymentGreaterThanAdvanceReturnValueError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.payment-list-items.amount-of-payment-greater-than-advance-return-value');
    }
}
